import React from 'react';
// Components
import Banner from '../../../components/Banner/Banner';
import ProductTable from '../../../components/ProductTable/ProductTable';
import './AuAltin.css';

const AuAltin = () => {
  // Table data
  const tableHeaders = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table1Rows = [
    [
      { content: "<strong>TKN-<br />Au1MC05</strong>" },
      { content: "%99.99 saflıkta Au kaplamalı mikroskop camı,<br />cam ve Au arasında 10 nm krom katman kaplanmıştır,<br />25 mm x 60 mm, 1.0 mm kalınlık, 1 Paket,<br />5 adet cam ihtiva eder.<br />Tek yüzeyi kaplamalıdır. Yüzeye yapışma mukavemeti Scoth tape ile kontrol edilmiştir." },
      { content: "<strong>5</strong>" },
      { content: "<strong>7488</strong>" },
    ],
  ];
  
  const table2Rows = [
    [
      { content: "<strong>TKN-<br />Au1MC10</strong>" },
      { content: "%99.99 saflıkta Au kaplamalı mikroskop camı,<br />cam ve Au arasında 10 nm krom katman kaplanmıştır,<br />25 mm x 60 mm, 1.0 mm kalınlık, 1 Paket,<br />10 adet cam ihtiva eder.<br />Tek yüzeyi kaplamalıdır. Yüzeye yapışma mukavemeti Scoth tape ile kontrol edilmiştir." },
      { content: "<strong>10</strong>" },
      { content: "<strong>13976</strong>" },
    ],
  ];
  
  const table3Rows = [
    [
      { content: "<strong>TKN-<br />Au1MC20</strong>" },
      { content: "%99.99 saflıkta Au kaplamalı mikroskop camı,<br />cam ve Au arasında 10 nm krom katman kaplanmıştır,<br />25 mm x 60 mm, 1.0 mm kalınlık, 1 Paket,<br />20 adet cam ihtiva eder.<br />Tek yüzeyi kaplamalıdır. Yüzeye yapışma mukavemeti Scoth tape ile kontrol edilmiştir." },
      { content: "<strong>20</strong>" },
      { content: "<strong>25956</strong>" },
    ],
  ];

  return (
    <div className="au-altin-page">
      {/* Main Content */}

      {/* Banner */}
      <Banner 
        title="Au (Altın) Kaplı Camlar" 
        backgroundImage={require('../../../assets/images/inner-banner.jpg')} 
      />

      {/* Page Content */}
      <section className="au-altin-content">
        <div className="container content-container">
          <div className="text-center">
            <p>
              %99.99 saflıkta altın (Au) kaplamalı mikroskop camları (25 mm x 60 mm, 1.0 mm kalınlığında). <br />
              Altın kaplama kalınlığı 100 nm dir. Bunun altında 10 nm Cr katmanı bulunmaktadır.
            </p>
          </div>
          <div className="image-wrapper text-center">
            <img 
              src={require('../../../assets/images/IMG_2419.jpg')} 
              alt="Au Kaplamalı Mikroskop Camı" 
              className="img-fluid"
            />
          </div>
          <h4 className="text-center">Altın (Au) Kaplamalı Mikroskop Camı (~100 nm)</h4>

          {/* Data Tables */}
          <div className="data-tables">
            <ProductTable 
              headers={tableHeaders}
              rows={table1Rows}
              className="table-1"
            />
            
            <ProductTable 
              headers={tableHeaders}
              rows={table2Rows}
              className="table-2"
            />
            
            <ProductTable 
              headers={tableHeaders}
              rows={table3Rows}
              className="table-3"
            />
          </div>
        </div>
      </section>

    </div>
  );
};

export default AuAltin;
